import React from 'react';
import PropTypes from 'prop-types';
import Perf from 'react-addons-perf';

const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  position: 'fixed',
  right: '50px',
  top: '20vw',
  padding: '10px',
  background: '#bada55',
  border: '2px solid black',
  textAlign: 'center',
  zIndex: 9999999,
};

const buttonStyle = {
  display: 'block',
  marginTop: '10px',
  padding: '5px',
};

class PerfWidget extends React.PureComponent {
  static propTypes = {};
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = { started: false };
  }

  toggle = () => {
    const { started } = this.state;

    started ? Perf.stop() : Perf.start();

    this.setState({ started: !started });
  };

  printWasted = () => {
    const lastMeasurements = Perf.getLastMeasurements();

    Perf.printWasted(lastMeasurements);
  };

  printOperations = () => {
    const lastMeasurements = Perf.getLastMeasurements();

    Perf.printOperations(lastMeasurements);
  };

  render() {
    if (process.env.NODE_ENV === 'production') {
      return null;
    }

    const { started } = this.state;

    return (
      <div style={boxStyle}>
        <button style={buttonStyle} onClick={this.toggle}>
          {started ? 'Stop' : 'Start'}
        </button>
        <button style={buttonStyle} onClick={this.printWasted}>
          Print Wasted
        </button>
        <button style={buttonStyle} onClick={this.printOperations}>
          Print Operations
        </button>
      </div>
    );
  }
}

export default PerfWidget;



// WEBPACK FOOTER //
// ./src/components/PerfWidget/PerfWidget.js